import {TaskQueue} from "aurelia-framework";
import {instance} from "../tools/di";

let startHooks = [];

export function addStartHook(callback) {
  if (startHooks) {
    startHooks.push(callback);
  } else {
    instance(TaskQueue).queueMicroTask(callback);
  }
}

export async function runStartHooks() {
  let taskQueue = instance(TaskQueue);
  startHooks.forEach(hook => taskQueue.queueMicroTask(hook));
  startHooks = null;
}

let systemHooks = [];

export async function runSystemHooks(application) {
  systemHooks.forEach(hook => hook());
  systemHooks = null;

  return application;
}

export function eagerInstance() {
  return function (target) {
    systemHooks.push(() => instance(target));
  }
}
